module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens12-0904088b78dee0e54b6b895e4b85d816.jpg";